import { ENDPOINTS } from 'src/constants/endpoints'

import { http } from 'src/interfaces/http'

export const signOut = async (): Promise<void> => {
  await http.get(ENDPOINTS.auth.signOut, { withCredentials: true })
}
